export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M12 22a10 10 0 1 1 10-10c0 5.523-4.477 10-10 10m-6-9h8l-3.5 3.5 1.42 1.42L17.84 12l-5.92-5.92L10.5 7.5 14 11H6z\"/>"
};